import React from 'react';
import { ShimmerCircularImage, ShimmerTitle, ShimmerThumbnail } from "react-shimmer-effects";
import { AiOutlineCaretRight } from "react-icons/ai";

const ObservationFrameworksLoader = () => {
  return (
    <>
      <div className='mg-t-25'>
        <div className='d-flex align-items-center'>
          <AiOutlineCaretRight size={20} />
          <div style={{ width: '54px' }}><ShimmerTitle line={1} gap={0} variant="primary" className="mg-l-10 mg-b-0" /></div>
        </div>
        <ShimmerTitle line={2} gap={5} variant="primary" className="mg-t-15 mg-b-0" />
        <div style={{ width: '80px' }}><ShimmerTitle line={1} gap={0} variant="primary" className="mg-t-15 mg-b-0" /></div>
        <ShimmerTitle line={2} gap={5} variant="primary" className="mg-t-15 mg-b-0" />
        <hr className='mg-t-18 mg-b-18 border-gray-300' />
        <div className='d-flex align-items-center'>
          <div className='col-8 pe-5'><ShimmerTitle line={1} gap={0} variant="primary" className="mg-b-0" /></div>
          <div className='col-4'><ShimmerTitle line={1} gap={0} variant="primary" className="mg-b-0" /></div>
        </div>
        <div style={{ width: '80px' }}><ShimmerTitle line={1} gap={0} variant="primary" className="mg-t-15 mg-b-0" /></div>
        <ShimmerTitle line={2} gap={5} variant="primary" className="mg-t-15 mg-b-0" />
        <div style={{ width: '80px' }}><ShimmerTitle line={1} gap={0} variant="primary" className="mg-t-15 mg-b-0" /></div>
        <ShimmerTitle line={2} gap={5} variant="primary" className="mg-t-15 mg-b-0" />
        <hr className='mg-t-18 border-gray-300 mb-0' />
      </div>

      <div className='mg-t-25 d-flex align-items-center'>
        <AiOutlineCaretRight size={20} />
        <div style={{ width: '150px' }}><ShimmerTitle line={1} gap={0} variant="primary" className="mg-l-10 mg-b-0" /></div>
      </div>
      <div className='mg-t-25 d-flex align-items-center'>
        <AiOutlineCaretRight size={20} />
        <div style={{ width: '54px' }}><ShimmerTitle line={1} gap={0} variant="primary" className="mg-l-10 mg-b-0" /></div>
      </div>
      <div className='mg-t-25 d-flex align-items-center'>
        <AiOutlineCaretRight size={20} />
        <div style={{ width: '73px' }}><ShimmerTitle line={1} gap={0} variant="primary" className="mg-l-10 mg-b-0" /></div>
      </div>
      <div className='mg-t-25 d-flex align-items-center'>
        <AiOutlineCaretRight size={20} />
        <div style={{ width: '94px' }}><ShimmerTitle line={1} gap={0} variant="primary" className="mg-l-10 mg-b-0" /></div>
      </div>
      <div className='mg-t-25 d-flex align-items-center'>
        <AiOutlineCaretRight size={20} />
        <div style={{ width: '57px' }}><ShimmerTitle line={1} gap={0} variant="primary" className="mg-l-10 mg-b-0" /></div>
      </div>
      <div className='mg-t-25 d-flex align-items-center'>
        <AiOutlineCaretRight size={20} />
        <div style={{ width: '73px' }}><ShimmerTitle line={1} gap={0} variant="primary" className="mg-l-10 mg-b-0" /></div>
      </div>
      <div className='mg-t-25 d-flex align-items-center'>
        <AiOutlineCaretRight size={20} />
        <div style={{ width: '54px' }}><ShimmerTitle line={1} gap={0} variant="primary" className="mg-l-10 mg-b-0" /></div>
      </div>
      <div className='mg-t-25 d-flex align-items-center'>
        <AiOutlineCaretRight size={20} />
        <div style={{ width: '54px' }}><ShimmerTitle line={1} gap={0} variant="primary" className="mg-l-10 mg-b-0" /></div>
      </div>
    </>
  );
};

export default ObservationFrameworksLoader;
